import { createSlice } from "@reduxjs/toolkit";

const initialJobState = {
  jobs: [],
  page: null,
  limit: null,
  watchList: [],
  totalPages: null,
  selectedJob: null,
  listLoading: false,
  dropDownJobs: [],
  totalResults: null,
  actionLoading: false,
  selectedJobId: typeof localStorage.getItem("selectedJobId") === "string" ? localStorage.getItem("selectedJobId") : null,
  selectedJobWithCandidates: null,
};

export const jobManagementSlice = createSlice({
  name: "jobManagementSlice",
  initialState: initialJobState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getAllJobs: (state, action) => {
      const { page, limit, totalPages, totalResults, jobs: results } = action?.payload?.jobs;
      state.jobs = results;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.page = page;
      state.listLoading = false;
    },
    saveJobs: (state, action) => {
      state.dropDownJobs = action?.payload?.data?.data?.jobs;
      state.listLoading = false;
    },
    getAllJobsWithoutPagination: (state, action) => {
      state.jobs = action?.payload?.data?.data?.jobs;
      state.listLoading = false;
    },
    setSelectedJob: (state, action) => {
      const { job } = action.payload;
      state.selectedJob = job;
      state.actionLoading = false;
    },
    setSelectedJobId: (state, action) => {
      const { id } = action.payload;
      state.selectedJobId = id;
    },
    setSelectedJobWithCandidates: (state, action) => {
      const { limit, page, totalPages, totalResults, jobDetail } = action?.payload?.job?.data;
      state.selectedJobWithCandidates = jobDetail;
      state.actionLoading = false;
      state.totalResults = totalResults;
      state.totalPages = totalPages;
      state.limit = limit;
      state.page = page;
    },
    cleanUpSelectedJob: (state, action) => {
      state.selectedJob = null;
    },
    setJobID: (state, action) => {
      state.jobId = action?.payload;
      state.actionLoading = false;
    },
    setWorkFlow: (state, action) => {
      state.workFlow = action?.payload;
    },
    getWatchList: (state, action) => {
      state.watchList = action?.payload;
      state.listLoading = false;
    },
  },
});
